import React from 'react';
import { Col } from 'react-bootstrap';
import QuestionGroups from "./QuestionGroups";

class QuestionSection extends React.Component {

    render() {
        if (this.props.section.name === "-") {
            return (
                <div className="row questionnaire__sections__section">
                    <QuestionGroups
                        testObj={this.props.testObj}
                        section={this.props.section.id}
                        qsi={this.props.qsi}
                    />
                </div>
            )
        } else {
            return (
                <div className="row questionnaire__sections__section">
                    <Col lg={12}>
                        <div className="panel panel-default">
                            <div className="panel-heading">{this.props.qsi}. {this.props.section.name}</div>
                            <div className="panel-body">
                                <QuestionGroups
                                    section={this.props.section.id}
                                    fid={this.props.section.form}
                                    qsi={this.props.qsi}
                                    testObj={this.props.testObj}
                                />
                            </div>
                        </div>
                    </Col>
                </div>
            )
        }
    }
}

export default QuestionSection;


// WEBPACK FOOTER //
// ./src/modules/form/view.1/QuestionSection.js